import { useCallback } from "react";

interface UseMFANavigationProps {
  setCurrentScreen: (screen: "login" | "mfaSelection" | "mfaCode") => void;
  setSelectedFactor: (factor: null) => void;
  setMfaError: (error: string | null) => void;
  setMfaErrorCode: (errorCode: string | null) => void;
  setInitialFactorType: (type: "email" | "sms" | undefined) => void;
  onCancel?: () => void;
}

export function useMFANavigation({
  setCurrentScreen,
  setSelectedFactor,
  setMfaError,
  setMfaErrorCode,
  setInitialFactorType,
  onCancel,
}: UseMFANavigationProps) {
  const handleMFACancel = useCallback(() => {
    onCancel?.();
    setInitialFactorType(undefined);
    setCurrentScreen("login");
    setSelectedFactor(null);
    setMfaError(null);
    setMfaErrorCode(null);
  }, [onCancel, setCurrentScreen, setSelectedFactor, setMfaError, setMfaErrorCode, setInitialFactorType]);

  const handleNavigateToFactorSelection = useCallback(
    (targetFactorType: "email" | "sms") => {
      setInitialFactorType(targetFactorType);
      setCurrentScreen("mfaSelection");
      setSelectedFactor(null);
      setMfaError(null);
      setMfaErrorCode(null);
    },
    [setCurrentScreen, setSelectedFactor, setMfaError, setMfaErrorCode, setInitialFactorType],
  );

  return { handleMFACancel, handleNavigateToFactorSelection };
}
